<template>
  <div class="md-layout">
    <booking-list></booking-list>
  </div>
</template>

<script>
import BookingList from "./BookingList.vue";

export default {
  data() {
    return {};
  },

  components: {
    BookingList
  },

  methods: {},

  watch: {},

  mounted() {}
};
</script>
